import { render, staticRenderFns } from "./pdxtfbt.vue?vue&type=template&id=0e54e7a2&scoped=true"
import script from "./pdxtfbt.vue?vue&type=script&lang=js"
export * from "./pdxtfbt.vue?vue&type=script&lang=js"
import style0 from "./pdxtfbt.vue?vue&type=style&index=0&id=0e54e7a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e54e7a2",
  null
  
)

export default component.exports